const Nav = {
  init: () => {
    const htmlEl = document.querySelector("html");
    const mobileNavBtn = document.querySelector(".main-header__btn-mobile-nav");

    if (mobileNavBtn) {
      mobileNavBtn.addEventListener("click", () => {
        if (htmlEl) {
          htmlEl.classList.toggle("mobile-nav--is-open");
        }
      });
    }
  },
};

export default Nav;
